/** @jsxImportSource @emotion/react */

import { EuiButtonGroup } from "@inscopix/ideas-eui";
export interface ButtonGroupTableGraphProps {
  selected: "TABLE" | "GRAPH";
  onChange: (view: "TABLE" | "GRAPH") => void;
}
export const ButtonGroupTableGraph = ({
  selected,
  onChange,
}: ButtonGroupTableGraphProps) => {
  return (
    <EuiButtonGroup
      buttonSize="m"
      type="single"
      legend="View"
      idSelected={selected}
      options={[
        {
          id: "TABLE" as const,
          label: "Table",
          "aria-label": "Table view",
        },
        {
          id: "GRAPH" as const,
          label: "Preview Graph",
          "aria-label": "Graph view",
        },
      ]}
      onChange={(id) => {
        onChange(id as "TABLE" | "GRAPH");
      }}
    />
  );
};
